// extracted by mini-css-extract-plugin
module.exports = {"product-edit-button":"product-edit-button--23lue","product-edit-button--nopadding":"product-edit-button--nopadding--23lue"};